export enum ECollections {
  Course = 'course',
  Lesson = 'lesson',
  Homework = 'homework',
  Access = 'access_v+',
  User = 'user',
  Order = 'order',
  Email = 'email',
  UserCourseProgress = 'user_course_progress',
  FrontendSettings = 'frontend_settings',
  NotificationSettings = 'notification_settings',
  SurveyAnswers = 'survey_answers',
  Subscription = 'subscription',
  Discount = 'discount',
}
